export const FETCH_FROM_UNTIL_DATE_REQUEST= "FETCH_FROM_UNTIL_DATE_REQUEST";
export const FETCH_DATE_CONFIG = "FETCH_DATE_CONFIG";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";
export const SET_FROM_DATE = "SET_FROM_DATE";
export const SET_UNTIL_DATE = "SET_UNTIL_DATE";

export const FETCH_OVERVIEW_REQUEST = "FETCH_OVERVIEW_REQUEST";
export const FETCH_OVERVIEW_SUCCESS = "FETCH_OVERVIEW_SUCCESS";

export const SET_OVERVIEW_DATA = "SET_OVERVIEW_DATA";
export const FETCH_OVERVIEWDETAILS_REQUEST = "FETCH_OVERVIEWDETAILS_REQUEST";
export const FETCH_OVERVIEWDETAILS_SUCCESS = "FETCH_OVERVIEWDETAILS_SUCCESS";
export const BACK_TO_OVERVIEW = "BACK_TO_OVERVIEW";

export const ENABLE_EDITABLE_FIELDS = "ENABLE_EDITABLE_FIELDS";
export const DISABLE_EDITABLE_FIELDS = "DISABLE_EDITABLE_FIELDS";
export const RESET_EDIT_TOGGLE_ON_BACK = "RESET_EDIT_TOGGLE_ON_BACK";

export const SET_OVERVIEWDETAILS_DATA_REQUEST = "SET_OVERVIEWDETAILS_DATA_REQUEST";
export const SET_OVERVIEWDETAILS_DATA = "SET_OVERVIEWDETAILS_DATA";
export const SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA = "SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA";

export const VALIDATE_OVERVIEWDETAILS = "VALIDATE_OVERVIEWDETAILS";
export const SAVE_OVERVIEWDETAILS_REQUEST = "SAVE_OVERVIEWDETAILS_REQUEST";
export const SAVE_OVERVIEWDETAILS_SUCCESS = "SAVE_OVERVIEWDETAILS_SUCCESS";

export const RESET_UPDATED_AND_ERROR_FLAGS = "RESET_UPDATED_AND_ERROR_FLAGS";
export const SET_SHOW_INSTRUCTION_MODEL = "SET_SHOW_INSTRUCTION_MODEL";

export const DETAILOVERVIEW_REQUEST_OR_SUCCESS = "DETAILOVERVIEW_REQUEST_OR_SUCCESS";

export const SHOW_CASH_REGISTER_CONFIRMATION_MODEL = "SHOW_CASH_REGISTER_CONFIRMATION_MODEL";
export const SHOW_UPLOAD_FILE_MODEL = "SHOW_UPLOAD_FILE_MODEL";
export const UPLOAD_CASH_REGISTER_REQUEST = "UPLOAD_CASH_REGISTER_REQUEST";
export const UPLOAD_CASH_REGISTER_SUCCESS = "UPLOAD_CASH_REGISTER_SUCCESS";

export const LOGOUT_YES = "LOGOUT_YES";

export const SELECTED_OVERVIEWDETAIL_OPTION_CHANGE = "SELECTED_OVERVIEWDETAIL_OPTION_CHANGE";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const IS_DETAILS_FILTER_APPLIED = "IS_DETAILS_FILTER_APPLIED";
export const FETCH_REMARK_OPTIONS = "FETCH_REMARK_OPTIONS";
export const SET_ERROR_LIST = "SET_ERROR_LIST";
export const SET_CASH_REGISTER_MANDATORY = "SET_CASH_REGISTER_MANDATORY";

export const CLEAR_OVERVIEW_FILTER = "CLEAR_OVERVIEW_FILTER";
export const IS_OVERVIEW_FILTER_APPLIED = "IS_OVERVIEW_FILTER_APPLIED";
export const SET_OVERVIEW_FILTER_DATA = "SET_OVERVIEW_FILTER_DATA";






